import { render, staticRenderFns } from "./Course5.vue?vue&type=template&id=3ba4924a&scoped=true"
import script from "./Course5.vue?vue&type=script&lang=ts"
export * from "./Course5.vue?vue&type=script&lang=ts"
import style0 from "@/assets/css/course.css?vue&type=style&index=0&id=3ba4924a&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba4924a",
  null
  
)

export default component.exports